const buildResetActiveCompanyScopeState = ({ state, initialState }) => {
  return {
    ...initialState,
    fixedWidth: state?.fixedWidth === true,
    workspaceSidebarCollapsed: state?.workspaceSidebarCollapsed === true,
    // Readiness describes this Mac, not the workspace.
    planRunReadiness: state?.planRunReadiness || null,
    // Plan choices belong to their thread or draft scope and persist across workspace switches.
    planRunSelectionByScopeKey: state?.planRunSelectionByScopeKey || initialState.planRunSelectionByScopeKey,
    prefs: state?.prefs && typeof state.prefs === 'object' ? state.prefs : initialState.prefs,
    settings: {
      ...(initialState.settings || {}),
      ...(state?.settings || {}),
      isLoading: false,
      isSaving: false,
      error: ''
    },
    automations: {
      ...(initialState.automations || {}),
      activePane: String(state?.automations?.activePane || '').trim() || initialState.automations.activePane
    }
  };
};

export default buildResetActiveCompanyScopeState;
